import dynamic from 'next/dynamic';
import styles from './index.module.scss';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function OceanProHomeSolarBattery() {
    return (
        <div className={`ocean-pro-home-solar-battery ${styles['ocean-pro-home-solar-battery']}`}>
            <IndexDynamic />
        </div>
    );
}
